import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-expanded"]

import { toRefs, computed } from 'vue'
import IconChevroneUpMedium from '../assets/icons/IconChevroneUpMedium.vue'
import IconChevroneUpSmall from '../assets/icons/IconChevroneUpSmall.vue'
interface EMITS {
  (e: 'onClicked')
}
interface Props {
  accordionText: string
  size: string
  active: boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'AccordionText',
  props: {
    accordionText: {},
    size: {},
    active: { type: Boolean }
  },
  emits: ["onClicked"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const { accordionText, size, active } = toRefs(props)
const emits = __emit
const accordionClassesText = computed(() => {
  if (size.value === 'medium') return 'accordion__text'
  if (size.value === 'small') return 'accordion__text__small'
  if (size.value === 'large') return 'accordion__text__large'
  if (size.value === 'extrasmall') return 'accordion__text__extrasmall'
  else return ''
})

const accordionClassesIcon = computed(() => {
  if (size.value === 'medium') return 'accordion__arrow-button__icon'
  if (size.value === 'extrasmall') return 'accordion__arrow-button__icon__small'
  if (size.value === 'small') return 'accordion__arrow-button__icon__small'
  if (size.value === 'large') return 'accordion__arrow-button__icon__large'
  else return ''
})

function onClicked(event?: Event, preventDefault?: boolean) {
  if (event && preventDefault) event.preventDefault() // Prevent space bar scrolling
  emits('onClicked')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "aria-expanded": _unref(active),
    class: "accordion",
    role: "button",
    tabindex: "0",
    onClick: onClicked,
    onKeydown: [
      _withKeys(onClicked, ["enter"]),
      _cache[0] || (_cache[0] = _withKeys((event) => onClicked(event, true), ["space"]))
    ]
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(accordionClassesText.value)
    }, _toDisplayString(_unref(accordionText)), 3),
    _createElementVNode("div", {
      class: _normalizeClass(["accordion__arrow-button", { 'accordion__arrow-button__rotated': !_unref(active) }])
    }, [
      (_unref(size) === 'medium' || _unref(size) === 'large')
        ? (_openBlock(), _createBlock(IconChevroneUpMedium, {
            key: 0,
            class: _normalizeClass(accordionClassesIcon.value)
          }, null, 8, ["class"]))
        : _createCommentVNode("", true),
      (_unref(size) === 'small' || _unref(size) === 'extrasmall')
        ? (_openBlock(), _createBlock(IconChevroneUpSmall, {
            key: 1,
            class: _normalizeClass(accordionClassesIcon.value)
          }, null, 8, ["class"]))
        : _createCommentVNode("", true)
    ], 2)
  ], 40, _hoisted_1))
}
}

})